import { Box } from '@wix/design-system';
import React from 'react';
import WixStudioLogo from '../../assets/images/wix-studio-logo.svg';
import { useIsStudioNewUi } from '../../hooks/useIsStudioNewUi';
import { SwitchPlanHeaderBanner } from './SwitchPlanHeaderBanner';
export const HeaderBanner = _ref => {
  let {
    shouldShowSwitchPlanBanner,
    logo = /*#__PURE__*/React.createElement(WixStudioLogo, null)
  } = _ref;
  const isStudioNewUi = useIsStudioNewUi();
  const shouldCenterSwitchPlanBanner = isStudioNewUi && shouldShowSwitchPlanBanner;
  return /*#__PURE__*/React.createElement(Box, {
    minHeight: "42px",
    width: "100%",
    verticalAlign: "middle",
    padding: "0 12px",
    boxSizing: "border-box",
    height: "50px"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: shouldCenterSwitchPlanBanner ? '1' : undefined
  }, logo), shouldShowSwitchPlanBanner && /*#__PURE__*/React.createElement(SwitchPlanHeaderBanner, null), shouldCenterSwitchPlanBanner && /*#__PURE__*/React.createElement(Box, {
    flex: "1"
  }));
};
//# sourceMappingURL=HeaderBanner.js.map